/*=========================================================================================
  File Name: moduleSubscription.js
  Description: Subscription Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleSubscriptionState.js'
import mutations from './moduleSubscriptionMutations.js'
import actions from './moduleSubscriptionActions.js'
import getters from './moduleSubscriptionGetters.js'

export default {
    isRegistered: false,
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}